// extracted by mini-css-extract-plugin
export default {"Main":"Main_Main__6rA7m","PageTitle":"Main_PageTitle__l2GXM","NoPacks":"Main_NoPacks__B8LMr","Spinner":"Main_Spinner__mBjqu"};